export const renewHeaderConfig = {
  headerTitle: 'Workpermit Details',
  headerDescription: 'Details of Workpermit',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
